<template>
    <div v-if="loading" class="loading-spinner-type-1 primary"></div>
    <CustomCheckbox
        v-else-if="!hasDefaultTags"
        :modelValue="modelValue"
        :inputKey="inputKey"
        @update:modelValue="onChanged"
        :options="checkboxTags"
        cssClass="custom-checkbox-type-5"
        :showLabel="showLabel"
    />
    <div v-else-if="$te(`fields.${inputKey}.no_results`)" class="p no-results">{{$t(`fields.${inputKey}.no_results`)}}</div>
</template>

<script>
    import { mapState, mapActions } from 'pinia';
    import { useAccountStore } from '@/stores/account';
    import CustomCheckbox from '@/components/elements/inputs/CustomCheckbox';

    export default {
        name: "CustomCheckboxTagsFilter",
        props: {
            modelValue: {
                type: Array,
                default: () => []
            },
            showLabel: {
                type: Boolean,
                default: true,
            },
            inputKey: {
                type: String,
                default: 'prospects_filter_tags'
            }
        },
        data() {
            return {
                loading: false
            };
        },
        components: {
            CustomCheckbox
        },
        computed: {
            ...mapState(useAccountStore, ['tags', 'hasDefaultTags']),
            checkboxTags() {
                var result = this.tags.map(tag => ({
                    noTranslate: true,
                    icon: 'tag',
                    ...tag
                }));
                return result.filter(tag => tag.count && tag.count > 0);
            }
        },
        methods: {
            ...mapActions(useAccountStore, ['getAccountTags']),
            onChanged(newValue) {
                this.$emit('update:modelValue', newValue);
            },
        },
        async mounted() {
            this.loading = true;
            await this.getAccountTags();
            this.loading = false;
        }
    }
</script>